import { Link } from "react-router-dom";
import { CONTACT_INFO } from "../data/content";

export default function Footer() {
  return (
    <footer className="bg-bark text-chalk pt-20 pb-6 mt-24 relative overflow-hidden" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <p className="specimen-label text-chalk/60 mb-3">A SeedKeepers Initiative</p>
            <h3 className="font-display text-3xl md:text-4xl leading-[1.15] mb-6 font-medium tracking-tight">
              Part of a broader vision for expert-led stewardship, restoration and Caring for Country.
            </h3>
            <p className="text-sm leading-relaxed text-chalk/80 max-w-md">
              SeedKeepers acknowledges Aboriginal and Torres Strait Islander
              peoples as the First Peoples of the lands and waters on which we
              work. We pay respect to Elders past, present and emerging, and
              recognise the enduring connection of Traditional Owners to
              Country.
            </p>
            <p className="mt-6 specimen-label text-ochre">SEED IS LIFE.</p>
          </div>

          <div className="md:col-span-3">
            <p className="specimen-label text-chalk/60 mb-4">Sitemap</p>
            <ul className="space-y-2 text-sm">
              {[
                ["/about", "About"],
                ["/stewardship", "Stewardship"],
                ["/services", "Services"],
                ["/infrastructure", "Infrastructure"],
                ["/projects", "Projects"],
                ["/stories", "Stories"],
                ["/seed-crisis", "Seed Crisis"],
                ["/genetics", "Genetics"],
                ["/seed-intelligence", "Seed Intelligence"],
                ["/permits", "Permits"],
                ["/training", "Training"],
                ["/resources", "Resources"],
                ["/contact", "Contact"],
              ].map(([to, label]) => (
                <li key={to}>
                  <Link to={to} className="hover:text-ochre transition-colors" data-testid={`footer-${label.toLowerCase().replace(/\s+/g, "-")}`}>
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="specimen-label text-chalk/60 mb-4">Contact</p>
            <p className="text-sm mb-1 text-chalk/80">{CONTACT_INFO.founder} · Founder</p>
            <a href={`mailto:${CONTACT_INFO.email}`} className="block text-sm hover:text-ochre transition-colors" data-testid="footer-email">
              {CONTACT_INFO.email}
            </a>
            <a href={`tel:${CONTACT_INFO.phone.replace(/\s+/g, "")}`} className="block text-sm hover:text-ochre transition-colors mt-1" data-testid="footer-phone">
              {CONTACT_INFO.phone}
            </a>
            <p className="text-sm text-chalk/70 mt-2">{CONTACT_INFO.location}</p>

            <p className="specimen-label text-chalk/60 mt-8 mb-3">In partnership with</p>
            <a href={CONTACT_INFO.partner.url} target="_blank" rel="noopener noreferrer" className="text-sm hover:text-ochre transition-colors" data-testid="footer-partner">
              National Indigenous Seed Bank Project ↗
            </a>

            <a href="/admin" className="block mt-8 link-mono text-chalk/70 hover:text-ochre" data-testid="footer-admin">
              Admin
            </a>
          </div>
        </div>

        <div className="rule mt-16 pt-6 flex flex-col md:flex-row justify-between gap-3 text-[10px] tracking-[0.25em] uppercase text-chalk/50 font-mono">
          <span>© {new Date().getFullYear()} SeedKeepers</span>
          <span>Australia · expert-led seed systems · Since {CONTACT_INFO.founderSince}</span>
          <span>Restoration begins with seed</span>
        </div>
      </div>

      {/* Massive watermark */}
      <div
        className="pointer-events-none absolute -bottom-6 md:-bottom-10 left-0 right-0 w-full text-center overflow-hidden select-none"
        aria-hidden="true"
      >
        <span className="font-display italic text-chalk/[0.06] font-medium tracking-tight leading-none whitespace-nowrap block"
              style={{ fontSize: "clamp(6rem, 22vw, 22rem)" }}>
          SeedKeepers
        </span>
      </div>
    </footer>
  );
}
